import Client from 'Utils/VisualforceClient/client';

const VisualforceClient = new Client();

export default VisualforceClient;
